import { Avatar, Flex, Text, Stack } from "@chakra-ui/react";
import { useSSO } from "../../context/SSO";

export default function UserInformation({ name, email, ...rest }) {
  const { user } = useSSO();

  const userEmail = user?.user?.email || ''
  const userName = user?.user?.username || ''

  return (
    <Flex gap="12px" align="center" {...rest}>
      <Avatar
        name={userName}
        w={["48px", "48px", "40px"]}
        h={["48px", "48px", "40px"]}
        color="white"
        fontWeight={800}
        fontSize="14px"
        bgGradient="linear(135deg, #2E84C8, #0073BB)"
      />
      <Stack
        align={["start", "start", "end"]}
        justify="center"
        spacing="4px"
        fontWeight={600}
      >
        <Text fontSize={["14px", "14px", "13px"]} color="#0073BB">
          {userName}
        </Text>

        <Text as="span" fontSize={["13px", "12px"]} color='#5C6066'>
          {userEmail}
        </Text>
      </Stack>
    </Flex>
  );
}
